// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class CrossRateKey {
    constructor(exp1, exp2) {
        this.exp1 = exp1;
        this.exp2 = exp2;
    }
    equals(other) {
        return (this.exp1.toLowerCase() === other.exp1.toLowerCase() && this.exp2.toLowerCase() === other.exp2.toLowerCase());
    }
    reverse() {
        return new CrossRateKey(this.exp2, this.exp1);
    }
    toString() {
        return `${this.exp1}/${this.exp2}`;
    }
}
